// extracted by mini-css-extract-plugin
export default {"left-panel":"DSICanvas_left-panel__3YMND","middle-panel":"DSICanvas_middle-panel__nd+ph"};